<template>

    <div class="dashBox">
            <!-- 系统列表 -->
            <a-table :columns="columnsS" :data-source="tableData"  :scroll="{ x: clientWidth}" :pagination="false"  :loading="tloading" :rowKey="(record,index)=>{return index}"
            bordered size="middle" @change="handleTableChange">
                <template slot="urlDetail" slot-scope="text">
                    <span >{{decodeURIComponent(text)}}</span>
                </template>
                <template slot="userBehave" slot-scope="record">
                    <a-icon style="color:#1890ff;" size="large" type="user" @click="handleUserBehaver(record)" />
                </template>
                <template slot="timeV" slot-scope="text">
                    <span :title="text + ' ms'">{{ text != 'null' ? (parseInt( text) / 1000).toFixed(0) : 'null' }}s</span>
                </template>
                <template slot="timeT" slot-scope="text">
                    <span :title="text + ' ms'">{{ text != 'null' ? (parseInt( text) / 1000).toFixed(2) : 'null' }}s</span>
                </template>

                <template slot="isFirst" slot-scope="text">
                    <span >{{ text == 0 ? '否' : '是' }}</span>
                </template>

                <!-- 操作类型 -->
                <template slot="logTypeS" slot-scope="text">
                    <span >{{ typeName[text] }}</span>
                </template>

                <!-- 链路 -->
                <template slot="traceBtn" slot-scope="text,record">
                    <a-button type="link" @click="handleRelation(record)">{{ text }}</a-button>
                </template>

                <template slot="readParams" slot-scope="text,record">
                    <a-icon style="color:#1890ff;" :loading="expandLoading" size="large" type="file-text" @click="handleParams(record)" />
                </template>

                <!-- 业务埋点Attrabutes -->
                <template slot="jsonParams" slot-scope="text,record">
                    <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParamsJson(record)" />
                </template>
            </a-table>
            <a-modal v-model="jsonModalVisable" title="attributes">
                <json-viewer
                :value="jsonVData"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-modal>
            <a-pagination  style="margin-left:20px;display:inline-flex;margin-top:20px;" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" @showSizeChange="handleSizeChange" :showSizeChanger="true"  show-less-items show-quick-jumper />
            
           <a-modal v-model="modalVisible" title="详情" :footer="null">
                <a-spin :spinning="expandLoading" ></a-spin>
                <div class="list_item_box">
                        <div class="list_item_data">
                            <div class="list_item_data_item" v-for="(item,index) in tempColum[0].children.filter((n) => { return n.dataIndex})" :key="index">
                                <div class="list_item_data_item_key">{{item.title}} <span>:</span></div>
                                
                                <span class="list_item_data_item_value" v-if="item.dataIndex == 'js_err_stack' || item.dataIndex == 'js_err_msg'" style="color:red;">{{ currentModalData[item.dataIndex] }}</span>
                                <span class="list_item_data_item_value" v-else>{{ currentModalData[item.dataIndex] }}</span>

                            </div>
                        </div>
                    </div>
            </a-modal>
    </div>
</template>

<script>
import JsonViewer from "vue-json-viewer"
const browserlist = [
    'chrome',
    'edge',
    'ie11',
    'ie',
    'firefox',
    'safari',
    'sgssapp',
    'wechat',
    'weibo',
    'uc',
    'sogou',
    'xiaomi',
    'baidu',
    '360',
    '2345',
    'qqbrowser',
    'qq',
    'opera',
]

const osList = [
    'windows',
    'macOS',
    'ios',
    'android',
]

const res_type_list = [
    'link',
    'img',
    'iframe',
    'css',
    'xmlhttprequest',
    'fetch',
    'navigation',
]
let pagenation ={
    current:1,
    pageSize:10,
    total:0
};
const typeName = {
    api:'接口请求',
    pv:'页面访问',
    click:'点击事件',
    resource:'资源加载超时',
    'js-error':'脚本错误',
    'pos-callback':'硬件信息',
    'pos-warn':'终端告警',
    'business-point':'业务埋点'
}
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagenation;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        },
        fixed: 'left'
    },
    {
        title: "用户行为",
        width:50,
        scopedSlots: { customRender: 'userBehave' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "用户信息",
        dataIndex: "user_sign",
        width:300,
        align: "center",
        sorter: true,

    },
    {
        title: "sessionID",
        dataIndex: "session_id",
        width:300,
        align: "center",
        sorter: true,
    },
    {
        title: "设备编码",
        dataIndex: "device_id",
        width:300,
        align: "center",
        sorter: true,
    },
    
    {
        title: "发生时间",
        dataIndex: "log_time",
        width:200,
        align: "center",
        sorter: true,

    }
]
const columsType = [
    {
        title: "操作类型",
        dataIndex: "log_type",
        width:100,
        align: "center",
        scopedSlots: { customRender: 'logTypeS' },
        defaultSortOrder :'descend',
        sorter: true,
    }
]
const columsApi = [
    {
        title: "接口请求",
        children:[
            {
                title: "状态码",
                dataIndex: "res_statues",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "请求耗时s",
                dataIndex: "res_duration",
                width:100,
                align: "center",
                scopedSlots: { customRender: 'timeT' },
                sorter: true,

            },
            {
                title: "链路",
                dataIndex: "res_traceid",
                width:300,
                align: "center",
                scopedSlots: { customRender: 'traceBtn' },
                ellipsis: true,
                sorter: true,

            },{
                title: "地址",
                dataIndex: "res_url",
                width:600,
                align: "center",
                ellipsis: true,
                sorter: true,

            },
        ]
    }
    
]
const columsPV = [
    {
        title: "页面访问",
        children:[
            {
                title: "首次访问",
                dataIndex: "pv_is_first",
                width:120,
                align: "center",
                scopedSlots: { customRender: 'isFirst' },
                ellipsis: true,
                sorter: true,

            },
            {
                title: "加载耗时s",
                dataIndex: "pv_loadtime",
                width:150,
                align: "center",
                scopedSlots: { customRender: 'timeT' },
                ellipsis: true,
                sorter: true,

            }
        ]
    }
    
]
const columsClick = [
    {
        title: "点击事件",
        children:[
            {
                title: "元素id",
                dataIndex: "ck_el_id",
                width:120,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "元素html",
                dataIndex: "ck_el_html",
                width:700,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "trackid",
                dataIndex: "ck_el_trackid",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "元素直接内容",
                dataIndex: "ck_el_content",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "元素类型",
                dataIndex: "ck_el_type",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "a标签href",
                dataIndex: "ck_el_href",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "点击位置",
                dataIndex: "ck_screen_x",
                width:150,
                align: "center",
                sorter: true,
            },
            {
                title: "点击位置",
                dataIndex: "ck_screen_y",
                width:150,
                align: "center",
                sorter: true,
            }
        ]
    }
    
]
const columsRes = [
    {
        title: "资源加载超时",
        children:[
            {
                title: "资源类型",
                dataIndex: "res_type",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "请求耗时s",
                dataIndex: "res_duration",
                width:100,
                align: "center",
                scopedSlots: { customRender: 'timeT' },
                sorter: true,

            },
            {
                title: "地址",
                dataIndex: "res_url",
                width:300,
                align: "center",
                sorter: true,

            },
        ]
    }
    
]
const columsJserr = [
    {
        title: "脚本错误",
        children:[
            {
                title: "错误类型",
                dataIndex: "js_err_name",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "错误消息",
                dataIndex: "js_err_msg",
                width:200,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "错误堆栈信息",
                dataIndex: "js_err_stack",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "详情",
                width:50,
                scopedSlots: { customRender: 'readParams' },
                align: "center",
                ellipsis: true,
            },
        ]
    }
    
]
const columsPosCall =  [
    {
        title: "硬件信息",
        children:[
            {
                title: "设备型号",
                dataIndex: "pos_device_model",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "设备系统版本号",
                dataIndex: "pos_device_sys_version",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "设备网络类型",
                dataIndex: "pos_device_network_type",
                width:100,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "主屏分辨率",
                dataIndex: "pos_device_display_main",
                width:100,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "副屏分辨率",
                dataIndex: "pos_device_display_second",
                width:100,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "收银软件版本号",
                dataIndex: "pos_device_software_version",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
        ]
    }
    
]
const columsPosWarn =  [
    {
        title: "终端告警",
        children:[
            {
                title: "告警类名",
                dataIndex: "pos_warn_class",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "告警名",
                dataIndex: "pos_warn_name",
                width:200,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "告警进程或堆栈",
                dataIndex: "pos_warn_thread",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "告警信息",
                dataIndex: "pos_warn_msg",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "详情",
                width:50,
                scopedSlots: { customRender: 'readParams' },
                align: "center",
                ellipsis: true,
            },
        ]
    }
    
]
const columsBusiness =  [
    {
        title: "业务埋点",
        children:[
            {
                title: "eventcode",
                dataIndex: "eventcode",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "eventname",
                dataIndex: "eventname",
                width:200,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "action",
                dataIndex: "action",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "business",
                dataIndex: "business",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "businesscode",
                dataIndex: "businesscode",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "attributes",
                dataIndex: "attributes",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,

            },
            {
                title: "自定义",
                width:150,
                scopedSlots: { customRender: 'jsonParams' },
                align: "center",
            },
            {
                title: "shopcode",
                dataIndex: "shopcode",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "shopname",
                dataIndex: "shopname",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "branchcode",
                dataIndex: "branchcode",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "branchname",
                dataIndex: "branchname",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "usercode",
                dataIndex: "usercode",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "openid",
                dataIndex: "openid",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "unionid",
                dataIndex: "unionid",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "deviceid",
                dataIndex: "deviceid",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "starttime",
                dataIndex: "starttime",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "endtime",
                dataIndex: "endtime",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "pagename",
                dataIndex: "pagename",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            
        ]
    }
    
]
const columsUser = [
    {
        title: "路由信息",
        children:[
            {
                title: "域名",
                dataIndex: "url_host",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },{
                title: "路由",
                dataIndex: "url_path",
                width:300,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "页面标题",
                dataIndex: "url_title",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
            {
                title: "前向地址",
                dataIndex: "referrer",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },{
                title: "前向域名",
                dataIndex: "referrer_host",
                width:150,
                align: "center",
                sorter: true,
                ellipsis: true,
            },
        ]
    },
    {
        title: "用户环境",
        children:[
            {
                title: "浏览器",
                dataIndex: "browser",
                width:100,
                align: "center",
                sorter: true,

            },{
                title: "系统",
                dataIndex: "os",
                width:100,
                align: "center",
                sorter: true,

            },
            {
                title: "软件版本",
                dataIndex: "app_version",
                width:100,
                align: "center",
                sorter: true,
            },
            {
                title: "窗口宽度",
                dataIndex: "screen_width",
                width:100,
                align: "center",
                sorter: true,

            },{
                title: "窗口高度",
                dataIndex: "screen_height",
                width:100,
                align: "center",
                sorter: true,
            },
            
        ]
    },
    {
        title: "用户信息",
        children:[
            {
                title: "用户ip",
                dataIndex: "__tag__:__client_ip__",
                width:150,
                align: "center",
                sorter: true,

            },{
                title: "国家",
                dataIndex: "country",
                width:80,
                align: "center",
                sorter: true,

            },{
                title: "省份",
                dataIndex: "province",
                width:150,
                align: "center",
                sorter: true,

            },{
                title: "市区",
                dataIndex: "city",
                width:150,
                align: "center",
                sorter: true,

            },{
                title: "服务商",
                dataIndex: "provider",
                width:150,
                align: "center",
                sorter: true,

            },
        ]
    },
];
export default {
    components:{
        JsonViewer
    },
    data () {
        return {
            tloading:false,
            pagenation,
            columnsS:[],
            tableData:[],
            clientWidth:800,
            expandLoading:false,
            orderStr:' order by log_time desc',
            searchP:{},
            typeName,
            tempColum:columsJserr,
            modalVisible:false,
            jsonModalVisable:false,
            jsonVData:{},
            currentModalData:{}
        }
    },
    mounted(){
        
        
    },
    props:{
    },
    methods:{
        handleUserBehaver(record){
            this.$router.push({
                path: "/monitorweb/userbehavior",
                query:{
                    session_id:record.session_id,
                    base_time:record.log_time
                }
            });
        },
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                
                this.orderStr = ' order by ' + sorter.field + ' ' + sorter.order.replace('end','');
            }
            else{
                this.orderStr = '';
            }
            this.pagenation.current = 1
            this.loadData();

        },
        handleParamsJson(item){
            this.jsonVData = JSON.parse(item.attributes)
            this.jsonModalVisable = true;
        },
        handleParams(item){
            if(item.js_err_name != 'null' ){
                this.tempColum = columsJserr
            }
            else{
                this.tempColum = columsPosWarn
            }
            this.currentModalData = item;
            this.modalVisible = true;
        },
        handleSizeChange(v,d){
            this.pagenation.pageSize = d
            this.pagenation.current = 1
            this.loadData();
        },
        handlePageChange(v){
            this.pagenation.current = v
            this.loadData();
        },
        getOtherWhereStr(slist){
            let result = '';
            for (let index = 0; index < slist.length; index++) {
                const element = slist[index];
                result+= " and browser != '"+element+"'";
            }
            return result;
        },
        loadData(){

            let that = this;
            let searchP = that.searchP;
            this.getColumns();
            //根据logType 组织 where
            let whereStr = " where project_name = '" + this.searchP.sleectedSys + "' ";
            if(searchP.logType != 'all'){
                whereStr += " and log_type like '%" +searchP.logType + "%'";
            }
            //通用条件
            if(searchP.session_id){
                whereStr += " and session_id = '" +searchP.session_id + "'";
            }
            if(searchP.device_id){
                whereStr += " and device_id = '" +searchP.device_id + "'";
            }
            if(searchP.user_sign){
                whereStr += " and user_sign like '%" +searchP.user_sign + "%'";
            }
            if(searchP.url_path){
                whereStr += " and url_path like '%" +searchP.url_path + "%'";
            }
            if(searchP.url_title){
                whereStr += " and url_title like '%" +searchP.url_title + "%'";
            }
            if(searchP.referrer){
                whereStr += " and referrer like '%" +searchP.referrer + "%'";
            }
            if(searchP.browser){
                if(searchP.browser != 'other'){
                    whereStr += " and browser like '%" +searchP.browser + "%'";
                }
                else{
                    whereStr += that.getOtherWhereStr(browserlist);
                }
            }
            if(searchP.app_version){
                if(searchP.app_version != ''){
                    whereStr += " and app_version like '%" +searchP.app_version + "%'";
                }
            }

            if(searchP.os){
                if(searchP.os != 'other'){
                    whereStr += " and os like '%" +searchP.os + "%'";
                }
                else{
                    whereStr += that.getOtherWhereStr(osList);
                }
            }
            //pv
            if(searchP.logType == 'pv'){
                
                // this.orderStr = ' order by pv_loadtime desc'

                if(searchP.isFirst != 1){
                    whereStr += (" and pv_is_first = '" +  (searchP.isFirst == 2 ? '1' : '0' ) + "'")
                }
                if(searchP.isLoad != 1){
                    if(searchP.isLoad == 2){
                        whereStr += " and pv_loadtime > 0 "
                    }
                    else{
                        whereStr += " and pv_loadtime = 0 "
                    }
                }
            }
            //click
            if(searchP.logType == 'click'){
                if(searchP.ck_el_id){
                    whereStr += " and ck_el_id like '%" +searchP.ck_el_id + "%'";
                }
                if(searchP.ck_el_html){
                    whereStr += " and ck_el_html like '%" +searchP.ck_el_html + "%'";
                }
                if(searchP.ck_el_trackid){
                    whereStr += " and ck_el_trackid = '" +searchP.ck_el_trackid + "'";
                }
                if(searchP.ck_el_content){
                    whereStr += " and ck_el_content like '%" +searchP.ck_el_content + "%'";
                }
                if(searchP.ck_el_type){
                    whereStr += " and ck_el_type like '%" +searchP.ck_el_type + "%'";
                }
                if(searchP.ck_el_href){
                    whereStr += " and ck_el_href like '%" +searchP.ck_el_href + "%'";
                }
            }

            //resource
            if(searchP.logType == 'resource'){
                // this.orderStr = ' order by res_duration desc'
                if(searchP.res_url){
                    whereStr += " and res_url like '%" +searchP.res_url + "%'";
                }
                if(searchP.res_type != 'other'){
                    whereStr += " and res_type like '%" +searchP.res_type + "%'";
                }
                else{
                    whereStr += that.getOtherWhereStr(res_type_list);
                }
            }

            //api
            if(searchP.logType == 'api'){
                // this.orderStr = ' order by res_duration desc'
                if(searchP.res_url){
                    whereStr += " and res_url like '%" +searchP.res_url + "%'";
                }
    
                if(searchP.res_traceid){
                    whereStr += " and res_traceid = '" +searchP.res_traceid + "'";
                }
                if(searchP.res_statues){
                    whereStr += " and res_statues = '" +searchP.res_statues + "'";
                }
            }

            //js-error
            if(searchP.logType == 'js-error'){
                if(searchP.js_err_name){
                    whereStr += " and js_err_name like '%" +searchP.js_err_name + "%'";
                }
    
                if(searchP.js_err_msg){
                    whereStr += " and js_err_msg like '%" + that.G.parseString(searchP.js_err_msg)  + "%'";
                }

                if(searchP.js_err_stack){
                    whereStr += " and js_err_stack like '%" +searchP.js_err_stack + "%'";
                }
            }

            //pos-callback
            if(searchP.logType == 'pos-callback'){
                if(searchP.pos_device_model){
                    whereStr += " and pos_device_model like '%" +searchP.pos_device_model + "%'";
                }
    
                if(searchP.pos_device_sys_version){
                    whereStr += " and pos_device_sys_version like '%" +searchP.pos_device_sys_version + "%'";
                }

                if(searchP.pos_device_network_type){
                    whereStr += " and pos_device_network_type like '%" +searchP.pos_device_network_type + "%'";
                }

                if(searchP.pos_device_software_version){
                    whereStr += " and pos_device_software_version like '%" +searchP.pos_device_software_version + "%'";
                }
            }

            //pos-warn
            if(searchP.logType == 'pos-warn'){
                if(searchP.pos_warn_class){
                    whereStr += " and pos_warn_class like '%" +searchP.pos_warn_class + "%'";
                }
    
                if(searchP.pos_warn_name){
                    whereStr += " and pos_warn_name like '%" +searchP.pos_warn_name + "%'";
                }

                if(searchP.pos_warn_thread){
                    whereStr += " and pos_warn_thread like '%" +searchP.pos_warn_thread + "%'";
                }

                if(searchP.pos_warn_msg){
                    whereStr += " and pos_warn_msg like '%" +searchP.pos_warn_msg + "%'";
                }
            }

            //business-point
            if(searchP.logType == 'business-point'){
                
                if(searchP.eventcode){
                    whereStr += " and eventcode like '%" +searchP.eventcode + "%'";
                }
    
                if(searchP.eventname){
                    whereStr += " and eventname like '%" +searchP.eventname + "%'";
                }

                if(searchP.action){
                    whereStr += " and action like '%" +searchP.action + "%'";
                }


                if(searchP.business){
                    whereStr += " and business like '%" +searchP.business + "%'";
                }

                if(searchP.businesscode){
                    whereStr += " and businesscode like '%" +searchP.businesscode + "%'";
                }

                if(searchP.attributes){
                    whereStr += " and attributes like '%" +searchP.attributes + "%'";
                }


                if(searchP.shopcode){
                    whereStr += " and shopcode like '%" +searchP.shopcode + "%'";
                }

                if(searchP.shopname){
                    whereStr += " and shopname like '%" +searchP.shopname + "%'";
                }

                
                if(searchP.branchcode){
                    whereStr += " and branchcode like '%" +searchP.branchcode + "%'";
                }

                if(searchP.branchname){
                    whereStr += " and branchname like '%" +searchP.branchname + "%'";
                }

                if(searchP.usercode){
                    whereStr += " and usercode like '%" +searchP.usercode + "%'";
                }

                if(searchP.unionid){
                    whereStr += " and unionid like '%" +searchP.unionid + "%'";
                }

                if(searchP.unionid){
                    whereStr += " and unionid like '%" +searchP.unionid + "%'";
                }

                if(searchP.deviceid){
                    whereStr += " and deviceid like '%" +searchP.deviceid + "%'";
                }

                if(searchP.starttime){
                    whereStr += " and starttime like '%" +searchP.starttime + "%'";
                }

                if(searchP.endtime){
                    whereStr += " and endtime like '%" +searchP.endtime + "%'";
                }

                if(searchP.pagename){
                    whereStr += " and pagename like '%" +searchP.pagename + "%'";
                }
                
            }

            let queryStr = "* | select *,"+
            "ip_to_country(\"__tag__:__client_ip__\") as country,"+
            "ip_to_province(\"__tag__:__client_ip__\") as province,"+
            "ip_to_city(\"__tag__:__client_ip__\") as city,"+
            "ip_to_provider(\"__tag__:__client_ip__\") as provider "+
            "from log " +
            whereStr
            +this.orderStr;
            that.tloading = true;
            let sTime = searchP.selectedTimeRange.split('~')[0];
            let eTime = searchP.selectedTimeRange.split('~')[1];
            let starttime = (new Date(sTime).getTime())/1000;
            let endtime = (new Date(eTime).getTime())/1000;
            let params = {
                projectname:'fp-zl-device',
                logstorename:searchP.selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:that.pagenation.pageSize,
                offset:(that.pagenation.current - 1) * that.pagenation.pageSize,
                reverse:false,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    result.list.forEach(element => {
                        element.id = that.G.generateUUID()
                    });
                    that.tableData = result.list;
                    that.pagenation.total = parseInt(result.count);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
  
        getColumns(){
            let logType = this.searchP.logType;
            this.columnsS = columns;
            this.columnsS = this.columnsS.concat(columsType);

            switch (logType) {
                case 'api':
                    this.columnsS = this.columnsS.concat(columsApi);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'pv':
                    this.columnsS = this.columnsS.concat(columsPV);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'click':
                    this.columnsS = this.columnsS.concat(columsClick);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'resource':
                    this.columnsS = this.columnsS.concat(columsRes);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'js-error':
                    this.columnsS = this.columnsS.concat(columsJserr);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'pos-callback':
                    this.columnsS = this.columnsS.concat(columsPosCall);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'pos-warn':
                    this.columnsS = this.columnsS.concat(columsPosWarn);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                case 'business-point':
                    this.columnsS = this.columnsS.concat(columsBusiness);
                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
                default:
                    this.columnsS = this.columnsS.concat(columsPV);
                    this.columnsS = this.columnsS.concat(columsApi);
                    this.columnsS = this.columnsS.concat(columsClick);
                    this.columnsS = this.columnsS.concat(columsJserr);
                    this.columnsS = this.columnsS.concat(columsBusiness);

                    this.columnsS = this.columnsS.concat(columsUser);
                    break;
            }
        },
        handleRelation(item){
            //链路上下十分钟时间
            let timePoint = item.log_time;
            let starttime = new Date(timePoint).getTime() - 10 * 60000;
            let endtime = new Date(timePoint).getTime() + 10 * 60000;
            // console.log("start:" + new Date(starttime).Format('yyyy-MM-dd hh:mm:ss'));
            // console.log("end:" + new Date(endtime).Format('yyyy-MM-dd hh:mm:ss'));
            let routeResolve = this.$router.resolve({
                path:"/monitorservice/relation",
                query:{
                    traceid:item.res_traceid,
                    url:item.res_url,
                    starttime:starttime,
                    endtime:endtime
                }
            })
            window.open(routeResolve.href, '_blank');
        }

    }
}

</script>
<style scoped>

.dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;

    }



</style>
